import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { CardConfiguration } from 'app/core/components/workflow-new/course/configurations/card-configuration';

@Component({
  selector: 'itpx-inner-card-presentation',
  templateUrl: './inner-card-presentation.component.html',
  styleUrls: ['../../common/style.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InnerCardPresentationComponent implements OnInit {

  @Input() conf: CardConfiguration;
  @Input() platformClass: any;
  private tagType: string;
  private expired: boolean;
  private supplements: string;
  private imageWidth: string;
  private imageHeight: string;
  private cardHeight: string;
  private cardWidth: string;
  private thumbnail: string;
  private readonly dateFormat: string = 'mediumDate'; //'d-MM-yyyy';

  constructor() { }

  ngOnInit() {
    Object.assign(this, this.conf);
    this.supplements = this.platformClass.productVariant && this.platformClass.productVariant.supplements ?
      this.platformClass.productVariant.supplements.join() : '';
    
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/course/inner-card-presentation/inner-card-presentation.component.ts